export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93')
];

export const server_loads = [];

export const dictionary = {
		"/": [9],
		"/admin/active_users": [10],
		"/admin/activity_log": [11],
		"/admin/asset_cleanup": [12],
		"/admin/chain_editor": [13],
		"/admin/cinema_sign_activity": [14],
		"/admin/cinema_sign_media": [15],
		"/admin/debug_tools": [16],
		"/admin/flm_peers": [17],
		"/admin/ftp_download_queue": [18],
		"/admin/ftp_sources": [19],
		"/admin/kdm_email_queue": [20],
		"/admin/locations": [21],
		"/admin/non_sync_player_activity": [22],
		"/admin/player_licenses": [23],
		"/admin/user_editor": [24],
		"/auth/confirm-mail": [25],
		"/auth/email-verification": [26],
		"/auth/lock-screen": [27],
		"/auth/login": [28],
		"/auth/recoverpw_p2": [30],
		"/auth/recoverpw": [29],
		"/auth/register": [31],
		"/auth/two-step-verification": [32],
		"/catcher-tms": [33,[2]],
		"/catcher-tms/about": [34,[2]],
		"/catcher-tms/features": [35,[2]],
		"/catcher-tms/roadmap": [36,[2]],
		"/cinema-sign": [37,[3]],
		"/cinema-sign/manual": [~39,[3]],
		"/cinema-sign/manual/[chapter]": [~40,[3]],
		"/cinema-sign/[topic]": [~38,[3]],
		"/dcp-cine-player": [~41],
		"/dcp-cine-player/activation": [43],
		"/dcp-cine-player/cinema-sign": [~44,[4]],
		"/dcp-cine-player/cinema-sign/[...legacy]": [~45,[4]],
		"/dcp-cine-player/manual": [~46,[5]],
		"/dcp-cine-player/manual/[chapter]": [~47,[5]],
		"/dcp-cine-player/[topic]": [~42],
		"/dcp_tools/assets": [48],
		"/dcp_tools/browser_upload": [49],
		"/dcp_tools/cpl_research": [50],
		"/dcp_tools/ingest_help": [52],
		"/dcp_tools/ingest": [51],
		"/dcp_tools/local_mp4_mov_to_dcp_maker": [53],
		"/dcp_tools/local_wa_dcp_player": [54],
		"/dcp_tools/wa_dcp_audio_fix": [55],
		"/dcp_tools/wa_dcp_cpl_rename": [56],
		"/dcp_tools/wa_dcp_sdr_to_hdr": [57],
		"/dcp_tools/wa_dcp_to_encrypted_dcp": [58],
		"/dcp_tools/welcome": [59],
		"/distributor/alloc_by_facility": [60],
		"/distributor/catcher_status": [61],
		"/distributor/reports": [62],
		"/distributor/transfer_monitor": [63],
		"/distributor/welcome": [64],
		"/donations": [65],
		"/free_tools": [66],
		"/inspect_tool": [67],
		"/kdmgen/admin": [68],
		"/kdmgen/device_certs": [69],
		"/kdmgen/facilities": [70],
		"/kdmgen/generate_kdm": [71],
		"/kdmgen/help": [72,[6]],
		"/kdmgen/help/[guide]": [73,[6]],
		"/kdmgen/register_cpl": [74],
		"/kdmgen/stats": [75],
		"/kdmgen/welcome": [76],
		"/movie_db": [77],
		"/non-sync-player": [78,[7]],
		"/non-sync-player/[topic]": [~79,[7]],
		"/pages/404": [80],
		"/pages/500": [81],
		"/pages/comingsoon": [82],
		"/pages/maintenance": [83],
		"/profile": [84],
		"/slate/booking_app": [85],
		"/slate/booking_offer_response": [86],
		"/slate/help": [87,[8]],
		"/slate/help/[guide]": [88,[8]],
		"/slate/movie_db": [89],
		"/slate/release_analysis": [90],
		"/slate/release_timeline": [91],
		"/slate/welcome": [92],
		"/welcome": [93]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';